<template>
  <div>
    <device-list deviceType="WQFX"></device-list>
  </div>
</template>

<script>
import DeviceList from "./DeviceList.vue";
export default {
  components: {
    DeviceList,
  },
};
</script>

<style lang="scss" scoped></style>
